
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import NodeInstance from "../../Global/nodeAxios";

const getVisaRequestData = createAsyncThunk(
  "api/vrf-visa",
  async ({ page, limit, search } = {}) => {
    try {
      const params = new URLSearchParams();
      if (page !== undefined && page !== null) params.append("page", page);
      if (limit !== undefined && limit !== null) params.append("limit", limit);
      if (search && typeof search === "string" && search.trim()) params.append("search", search.trim());

      const query = params.toString() ? `?${params.toString()}` : "";
      const response = await NodeInstance.get(`/dashboard/vrf-visa${query}`);
      return response.data;
    } catch (e) {
      throw new Error(e.message);
    }
  }
);

const visaRequestDataSlice = createSlice({
  name: "vrf-visa",
  initialState: {
    data: null,
    pagination: null,
    error: "",
    status: false,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getVisaRequestData.fulfilled, (state, action) => {
        state.data = action.payload.data;
        state.pagination = action.payload.pagination || null;
        state.isLoading = false;
        state.status = true;
      })
      .addCase(getVisaRequestData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getVisaRequestData.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});

export { getVisaRequestData };
export default visaRequestDataSlice.reducer;
